import { render, staticRenderFns } from "./ParametroFormDialog.vue?vue&type=template&id=23ac2202&scoped=true&"
import script from "./ParametroFormDialog.vue?vue&type=script&lang=js&"
export * from "./ParametroFormDialog.vue?vue&type=script&lang=js&"
import style0 from "./ParametroFormDialog.vue?vue&type=style&index=0&id=23ac2202&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ac2202",
  null
  
)

export default component.exports